import React from 'react';
import { Box, Button } from 'web-library';
import { useHistory } from 'react-router-dom';


import { makeStyles } from 'tss-react/mui';
import RouteKey from '../../../../routes/key';

const { amendment } = RouteKey.child;
const { coordinatorExamRegistrations } = RouteKey.amendment.child;

const useStyles = makeStyles()((theme) =>
({
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  button: {
    marginRight: theme.spacing(2),
  },
}));

const ResitEmailSuccess = () => {
  const { classes } = useStyles();
  const history = useHistory();
  return (
    <Box className={classes.buttonContainer}>
      <Button
        className={classes.button}
        onClick={() => history.push(`/${amendment}/${coordinatorExamRegistrations.route}`)}
      >
        View Registered Exams
      </Button>
    </Box>
  );
};

export default ResitEmailSuccess;
